export default "__VITE_ASSET__BUPlILhM__"